export default {
  install(Vue, options) {
    Vue.prototype.$History = {
      VideoObjectShow:false,
      VideoPlateNumber:"",
      VideoTime:"",
      VideoObject:[],
      HisinitShow:false,
      FleetID:0,
      TimeZone:'',
      HSubFleetvar:false,
      HUnitid:0,
      UnitArr:[],
      CurrentUnitObj:{},
      HStartTime:'00:00',
      HEndTime:'23:59',
      HStartdate:'',
      HEnddate:'',
      UnitDateTimeHistoryObj:'',
      HistoryCurrentNum:0,
      HistoryNum:0,
      HistoryPageNum:0,
      CurrentHistoryPage:0,
      Nextmultiplication_num:0,
      Backmultiplication_num:0,
      PlayNextIntervalID:'',
      RewindIntervalID:'',
      ShowTraceCheckbox:'Iconcheckbox-active',
      TraceCheckboxValue:true,
      ShowTraceLineCheckbox:'Iconcheckbox-active',
      TraceLineCheckboxValue:true,
      ShowPlaybackCheckbox:'Iconcheckbox',
      PlaybackValue:false,
      PlaybackLoading:false,
      QueryPlayBackNum:0,
      NoneQueryPlayBackNum:0,
      NoPlayBack:true,
      PlayBackData:[],
      PlayBackthead:[          
      ],
      eventPositionID:'-1',
      EventResourceArrFilter:[],
      PlayBackCh:0,
      MDVRJSONObj:[],
      lastPlayBackCallTime:0,
      //關閉影片
      CloseVideo(){
        this.VideoObjectShow = false
        this.VideoObject = []
        //關閉playing
        for(var i=0 ; i<this.PlayBackData.length;i++){
          if(this.PlayBackData[i].playing){
            Vue.prototype.$set(this.PlayBackData[i],'playing',false)
            break;
          }
        }
      },
      //打開事件影片
      OpenEventVideo(Obj,index){//Obj:event Obj\
        this.VideoObjectShow = false
        this.VideoObject = []
        this.GetEventMPG(index,Obj)
      },
      //取得事件影片資訊
      GetEventMPG(index,Obj){
        var lensname = ''
        var mp4 = ''
        Vue.prototype.$APIjs.GetEventMPG(localStorage.getItem('token'),Obj.unitId,Obj.positionDateTimeGMT.replace('T', ' '),index+1,1).then(result=>{
          mp4 = result.obj
          lensname = Vue.prototype.$Global.OneConvertToFirst(index+1)
          this.VideoObject.push({src:mp4,Name:lensname+' '+Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].lens,Videoindex:index.toString()})
          this.VideoObject = Vue.prototype.$Global.sortByKey(this.VideoObject,'Videoindex')
          this.VideoObjectShow = true
        })
      },
      //處理事件列表 Filter History 中沒有的
      FixEventResourceFilterArr(){
        this.EventResourceArrFilter = []
        if(Vue.prototype.$Report.EventResourceArr && this.UnitDateTimeHistoryObj){
          for(var j=0 ; j <Vue.prototype.$Report.EventResourceArr.length ; j++){
              for(var i = 0 ; i<this.UnitDateTimeHistoryObj.length ; i++){
                  if(this.UnitDateTimeHistoryObj[i].eventType == 'A' && this.UnitDateTimeHistoryObj[i].reportId == Vue.prototype.$Report.EventResourceArr[j].eventReportID ){
                    this.EventResourceArrFilter.push(Vue.prototype.$Report.EventResourceArr[j])
                    break;
                  }
              }
          }
        }
      },
      //歷史軌跡換頁
      ChangeHistoryPage(status){
        switch (status) {
          case 'pre':
            if(this.CurrentHistoryPage > 1){
              this.CurrentHistoryPage--
            }
            break;
          case 'next':
            if(this.CurrentHistoryPage < this.HistoryPageNum){
              this.CurrentHistoryPage++
            }
            break;
          case 'first':
            if(this.CurrentHistoryPage > 1){
              this.CurrentHistoryPage = 1
            }
            break;
          case 'last':
            if(this.CurrentHistoryPage < this.HistoryPageNum){
              this.CurrentHistoryPage = this.HistoryPageNum
            }
            break;        
          default:
            break;
        }
        Vue.prototype.$(".VehicleTbody-large").scrollTop(0);
      },
      //打開回放影片
      OpenPlayBackVideo(Obj){//
        // console.log(Obj)
        if(Obj.playing){
          this.CloseVideo()
          return
        }else{
          const now = new Date().getTime();
          if (now - this.lastCallTime < 1500) {
            console.log("呼叫過於頻繁，請稍後再試。");
            return;
          }
          this.lastCallTime = now;
          console.log("播放回放影片");
        }
        this.VideoTime=Obj.Time
        this.CloseVideo()
        if (!Obj.Url.includes('.mp4')) {
          Vue.prototype.$Global.load = true
          Vue.prototype.$APIjs.tryPlayBackUrl(Obj.Url).then(result=>{
            console.log(result)
            Vue.prototype.$Global.load = false
            // console.log(result)
            if(result == 'Upload Complete'){
              var CH = this.PlayBackCh+1;
              const formatted = Vue.prototype.moment(this.VideoTime, 'YYYY/MM/DD HH:mm:ss').format('_YYYYMMDD_HHmmss');
              Obj.Url = jsonObject.FileServer+'/video/'+this.CurrentUnitObj.mdvrid+'/file/CH'+CH+formatted+'.mp4'
              // console.log(Obj.Url)
            }
            this.VideoObject.push({time:Obj.Time,src:Obj.Url,Name:Obj.CHName})
            setTimeout(() => {
              Vue.prototype.$set(Obj,'playing',true)
            }, 250);
            setTimeout(() => {
              this.VideoObjectShow = true
              // setTimeout(() => {
              //   this.GetPlayBackList(false)
              //   for(var i = 0 ; i <4 ; i++){
              //     setTimeout(() => {
              //       this.GetPlayBackList(false)
              //     }, 20 * 1000);
              //   }
              // }, 60*1000); // 1分鐘後開始執行
            }, 500);
          })
        }else{
          this.VideoObject.push({time:Obj.Time,src:Obj.Url,Name:Obj.CHName})
          setTimeout(() => {
            Vue.prototype.$set(Obj,'playing',true)
          }, 250);
          setTimeout(() => {
            this.VideoObjectShow = true
          }, 500);
        }
      },
      //下載回放影片
      DowloadPlayBackVideo(Obj){
        const xhr = new XMLHttpRequest();
        xhr.open('GET', Obj.Url, true);
        xhr.responseType = 'blob';
        xhr.onload = function() {
          const blob = new Blob([xhr.response], { type: 'video/mp4' });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = Obj.CHName+Obj.Time;
          link.click();
          URL.revokeObjectURL(blobUrl);
        };
        xhr.send();
      },
      //變更回放資料
      ChangePlayBackData(){
        this.PlayBackthead = [
          {name:Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].channel,index:'CHName'},
          {name:Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].time,index:'Time'},
          {name:Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].action,index:'Url'}
        ]
      },
      //變更車隊
      ChangeFleet(){
        //Call GetfleetUnit API
        Vue.prototype.$APIjs.GetfleetUnit(localStorage.getItem('token'),this.FleetID,this.HSubFleetvar,3,'null').then(result=>{//參數 0 表示 All 不filter 連線狀態 'null' 表示不filter 車牌 
          this.UnitArr = []
          this.UnitArr = result.obj.unitInfo.sort(function(a, b){
              if(a.identifier < b.identifier) { return -1; }
              if(a.identifier > b.identifier) { return 1; }
              return 0;
          })
          this.HUnitid = 0
        })
      },
      //YYYYMMDDhhmmss 轉 UTC 
      YYYYMMDDhhmmssToUTC(YYYYMMDDhhmmss){
        var DateTimeArr = YYYYMMDDhhmmss.split('')
        var UTC = DateTimeArr[0]+DateTimeArr[1]+DateTimeArr[2]+DateTimeArr[3]+'-'+DateTimeArr[4]+DateTimeArr[5]+'-'+DateTimeArr[6]+DateTimeArr[7]+'T'+
        DateTimeArr[8]+DateTimeArr[9]+':'+DateTimeArr[10]+DateTimeArr[11]+':'+DateTimeArr[12]+DateTimeArr[13]
        return UTC
      },
      //取的攝影機紀錄錯誤時 初始化資料
      GetCameraUploadRecordErrorFunc(data){
        // console.log(data.responseJSON.detail)
        Vue.prototype.$History.PlayBackData = ''
        Vue.prototype.$History.VideoPlateNumber = ''
        Vue.prototype.$History.VideoTime = ''
        Vue.prototype.$History.PlaybackLoading  = false
        Vue.prototype.$History.NoPlayBack = false
      },
      //避開 0,0 及 null,null
      UnitInfoFilterLatLngNull(UnitInfo){
        var newUnitInfo = []
        for(var i=0 ; i<UnitInfo.length;i++){
          if(UnitInfo[i].latitude != null && UnitInfo[i].latitude != 0){
            newUnitInfo.push(UnitInfo[i])
          }
        }
        return newUnitInfo
      },
      //HTML 轉換成JSON
      HTMLConvertToJSON(htmlString){
        const regex = /<a\s+href='([^']+)'\s*>([^<]+)<\/a>/g;
        let match;
        const result = [];
        while ((match = regex.exec(htmlString)) !== null) {
          result.push({
            href: match[1],
            text: match[2].trim()
          });
        }
        return JSON.stringify(result, null, 2);
      },
      //解析MDVRList連結
      parseLink(link) {
        const regex = /CH(\d+)_(\d{4})(\d{2})(\d{2})_(\d{2})(\d{2})(\d{2})\.mp4/;
        const match = link.match(regex);
        if (match) {
          const channel = parseInt(match[1]);
          const year = parseInt(match[2]);
          const month = parseInt(match[3]);
          const day = parseInt(match[4]);
          const hour = parseInt(match[5]);
          const minute = parseInt(match[6]);
          const second = parseInt(match[7]);
      
          const time = new Date(year, month - 1, day, hour, minute, second);
          const formattedTime = Vue.prototype.$Global.FixDateTimeFormat(time)
          const result = {
            CH: channel-1,
            Time: formattedTime,
            Url:link
          };
      
          return result;
        } else {
          return null;
        }
      },
      GetPlayBackList(Search){
        var MDVRID = ''
        if(this.CurrentUnitObj.mdvrid ==null || this.CurrentUnitObj.mdvrid ==''){
          MDVRID = this.CurrentUnitObj.modemID
        }else{
          MDVRID = this.CurrentUnitObj.mdvrid
        }
        var HStartdate = this.HStartdate.replace(/-/g, '');
        var HEnddate = this.HEnddate.replace(/-/g, '');
        // console.log(Search)
        if(Search){
          this.PlayBackData = []
          this.PlaybackLoading = true
          this.MDVRJSONObj = []
        }
        var func = 'getMDVRPlayBackList'
        if(JSON.parse(this.CurrentUnitObj.mdvrjson).Mode == 'OnDemand'){
          func = 'getMDVRPlayBackList2'
        }
        this.VideoPlateNumber = this.CurrentUnitObj.identifier
        Vue.prototype.$APIjs[func](MDVRID,HStartdate,this.PlayBackCh).then(result=>{
          // console.log(result)
          this.PlaybackLoading = false
          var PlayBackDataStart =  JSON.parse(this.HTMLConvertToJSON(result.obj))
          // On Demand 程式
          for(var i = 0 ; i<PlayBackDataStart.length;i++){
            if(PlayBackDataStart[i].href.includes('.mp4')){
              PlayBackDataStart[i]= this.parseLink(jsonObject.FileServer+PlayBackDataStart[i].href)
            }else{
              const timeMatch = PlayBackDataStart[i].href.match(/time=([^&]+)/);
              const time = timeMatch ? timeMatch[1] : null;
              const formattedTime = Vue.prototype.$Global.FixDateTimeFormat(time);
              PlayBackDataStart[i]= {
                CH: this.PlayBackCh,
                Time: formattedTime,
                Url:jsonObject.MDVRAPIUrl+PlayBackDataStart[i].href
              }
            }
          }
          //轉換名稱
          if(this.CurrentUnitObj.mdvrjson != null || this.CurrentUnitObj.mdvrjson != ''){
            this.MDVRJSONObj = JSON.parse(this.CurrentUnitObj.mdvrjson).MDVRJsonObj
            // console.log(this.MDVRJSONObj)
            for(var i = 0 ; i<PlayBackDataStart.length;i++){
              if(this.MDVRJSONObj[PlayBackDataStart[i].CH] != undefined){
                PlayBackDataStart[i].CHName= this.MDVRJSONObj[PlayBackDataStart[i].CH].Name
              }
            }
          }else{
            for(var i = 0 ; i<PlayBackDataStart.length;i++){
              PlayBackDataStart[i].CHName= PlayBackDataStart[i].CH+1
            }
          }
          // console.log(PlayBackDataStart)
          // //filter 時間區間
          var StartDateTime = new Date(this.HStartdate+ ' ' + this.HStartTime);
          var EndDateTime = new Date(this.HEnddate+ ' '  + this.HEndTime);
          var PlayBackData_ = []
          for(var i = 0 ; i < PlayBackDataStart.length;i++){
            if(new Date(PlayBackDataStart[i].Time) >= StartDateTime && new Date(PlayBackDataStart[i].Time) <= EndDateTime){
              PlayBackData_.push(PlayBackDataStart[i])
            }
          }
          if(this.HStartdate != this.HEnddate){
            Vue.prototype.$APIjs[func](MDVRID,HEnddate,this.PlayBackCh).then(result=>{
              var PlayBackDataEnd =  JSON.parse(this.HTMLConvertToJSON(result.obj))
              // console.log(PlayBackDataEnd)
              // On Demand 程式
              for(var i = 0 ; i<PlayBackDataEnd.length;i++){
                // 1. 使用正則表達式取出 time 參數值
                if(PlayBackDataEnd[i].href.include('.mp4')){
                  PlayBackDataEnd[i]= this.parseLink(jsonObject.FileServer+PlayBackDataEnd[i].href)
                }else{
                  const timeMatch = PlayBackDataEnd[i].href.match(/time=([^&]+)/);
                  const time = timeMatch ? timeMatch[1] : null;
                  const formattedTime = Vue.prototype.$Global.FixDateTimeFormat(time);
                  PlayBackDataEnd[i]= {
                    CH: this.PlayBackCh,
                    Time: formattedTime,
                    Url:jsonObject.MDVRAPIUrl+PlayBackDataEnd[i].href
                  }
                }
              }
              // //轉換名稱
              if(this.CurrentUnitObj.mdvrjson != null){
                this.MDVRJSONObj = JSON.parse(this.CurrentUnitObj.mdvrjson).MDVRJsonObj
                for(var i = 0 ; i<PlayBackDataEnd.length;i++){
                  if(this.MDVRJSONObj[PlayBackDataEnd[i].CH].Name == null || this.MDVRJSONObj[PlayBackDataEnd[i].CH].Name == ''){
                    PlayBackDataEnd[i].CHName= PlayBackDataEnd[i].CH+1
                  }else{
                    PlayBackDataEnd[i].CHName= this.MDVRJSONObj[PlayBackDataEnd[i].CH].Name
                  }
                }
              }else{
                for(var i = 0 ; i<PlayBackDataEnd.length;i++){
                  PlayBackDataEnd[i].CHName= PlayBackDataEnd[i].CH+1
                }
              }
              //filter 時間區間
              for(var i = 0 ; i < PlayBackDataEnd.length;i++){
                if(new Date(PlayBackDataEnd[i].Time)>= StartDateTime && new Date(PlayBackDataEnd[i].Time) <= EndDateTime){
                  PlayBackData_.push(PlayBackDataEnd[i])
                }
              }
            })
          }
          if(!Search && this.VideoObject[0]){
            for(var i = 0 ; i<PlayBackData_.length;i++){
              for(var j = 0 ; j<this.PlayBackData.length ; j++){
                if(PlayBackData_[i].Time == this.PlayBackData[j].Time){
                  Vue.prototype.$set(this.PlayBackData,j,PlayBackData_[i])
                  break;
                }
              }
              if(j == this.PlayBackData.length){
                this.PlayBackData.push(PlayBackData_[i])
              }
            }
          }else{
            this.PlayBackData = Vue.prototype.$Global.sortByKey(PlayBackData_,'Time')
          }
          //處理PlayBackData播放狀態
          for(var i=0 ; i<this.PlayBackData.length;i++){
            Vue.prototype.$set(this.PlayBackData[i],'playing',false)
          }
          if(!Search && this.VideoObject[0]){
            for(var i=0 ; i<this.PlayBackData.length;i++){
              if(this.PlayBackData[i].Time == this.VideoObject[0].time && this.PlayBackData[i].CHName == this.VideoObject[0].Name){
                Vue.prototype.$set(this.PlayBackData[i],'playing',true)
                break;
              }
            }
          }
          // console.log(this.PlayBackData)
        })
      },
      //查詢歷史軌跡
      SearchHistory(){
        //刪除PlayBack列表 及 關閉PlayBack Video
        this.PlayBackData = []
        this.CloseVideo();
        this.VideoPlateNumber = ''
        this.VideoTime = ''
        //關閉網頁操作
        Vue.prototype.$Global.Noneactive = 'None-active'
        this.StopTrackHistory()
        if(this.FleetID == 0){
          alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].no_select_Fleet)
        }
        if(this.HUnitid == 0){
          alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].no_select_Unit_ID)
          Vue.prototype.$Global.Noneactive = ''
          return
        }
        var HStartUTCDateTime = Vue.prototype.$Global.TimeZoneObject.TimeZoneDateToUTC(new Date(this.HStartdate.replaceAll('-','/')+ ' ' + this.HStartTime + ':00'),this.TimeZone)
        var HEndUTCDateTime = Vue.prototype.$Global.TimeZoneObject.TimeZoneDateToUTC(new Date(this.HEnddate.replaceAll('-','/')+ ' ' + this.HEndTime + ':00'),this.TimeZone)
        if(HStartUTCDateTime > HEndUTCDateTime){
          alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].start_time_is_greater_than_end_time)
          Vue.prototype.$Global.Noneactive = ''
          return 
        }
        if(this.PlaybackValue){//Playback 卡一天
          if((new Date(HEndUTCDateTime) - new Date(HStartUTCDateTime))/(1000 * 3600 * 24)>1){
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].Play_back_query_for_up_to_1_day)
            Vue.prototype.$Global.Noneactive = ''
            return
          }
        }
        if((new Date(HEndUTCDateTime) - new Date(HStartUTCDateTime))/(1000 * 3600 * 24)>14){//History 卡14天
          alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].historical_track_query_for_up_to_14_days)
          Vue.prototype.$Global.Noneactive = ''
          return
        }
        var limit = '';
        if(this.TraceCheckboxValue && Vue.prototype.$Global.MapType == 'Google'){
          limit = jsonObject.HisoryLimit
        }
        Vue.prototype.$Global.load = true
        Vue.prototype.$Global.RemoveHistory()//刪除前一筆歷史軌跡
        switch (Vue.prototype.$Global.MapType) {
          case 'Google':
            if(Vue.prototype.$GoogleMap.HistoryUnitMarker != ''){
              Vue.prototype.$GoogleMap.RemoveOverlayMarkers(Vue.prototype.$GoogleMap.HistoryUnitMarker)
            }
            break;
          case 'Leaflet':
            if(Vue.prototype.$LeafletMap.ciLayer != ''){
              Vue.prototype.$LeafletMap.RemoveciLayer()
            }
            if(Vue.prototype.$LeafletMap.AccOnOffciLayer != ''){
              Vue.prototype.$LeafletMap.RemoveAccOnOffciLayer()
            }
            break;          
          default:
            break;
        }
        if(this.PlaybackValue){//Play Back 啟動
          this.QueryPlayBackNum++;
          // console.log(this.HStartdate+ ' ' + this.HStartTime)
          // console.log(this.HEnddate+ ' '  + this.HEndTime)
          // console.log(this.CurrentUnitObj)
          this.PlayBackCh = 0
          this.GetPlayBackList(true)
          // 新程式MDVR
          // Vue.prototype.$APIjs.getMDVRPlayBackList().then(result=>{
          //   console.log(result)
          //   this.PlaybackLoading = false
          // })
          // 舊程式OTUS
          // Vue.prototype.$APIjs.GetCameraUploadRecord(localStorage.getItem('token'),this.HUnitid,Vue.prototype.$Global.ChangeDateFormat(HStartUTCDateTime),Vue.prototype.$Global.ChangeDateFormat(HEndUTCDateTime),this.GetCameraUploadRecordErrorFunc).then(result=>{
          //   this.TimeZone = Vue.prototype.$Global.getTimeZone(this.FleetID)
          //   this.PlaybackLoading = false
          //   Vue.prototype.$Vehicle.VideoPlateNumber = this.PlateNumber
          //   if(result.obj.cameraUploadList.length >0){
          //     this.PlayBackData = result.obj.cameraUploadList.reverse()
          //     for(var i = 0 ; i<this.PlayBackData.length;i++){
          //       this.PlayBackData[i].startDateTime = this.YYYYMMDDhhmmssToUTC(this.PlayBackData[i].startDateTime)
          //     }
          //   }else{
          //     this.NoPlayBack = true
          //   }
          // })
        }else{
          this.PlayBackData = [];
          this.NoneQueryPlayBackNum++;
        }
        //Page歸零
        this.CurrentHistoryPage = 0
        this.HistoryPageNum = 0
        //清掉目前資料
        this.UnitDateTimeHistoryObj = ''
        this.HistoryNum = 0
        this.HistoryCurrentNum = ''
        this.eventPositionID = '-1'
        Vue.prototype.$APIjs.GetHistory(this.HUnitid,HStartUTCDateTime,HEndUTCDateTime,localStorage.getItem('token'),limit).then(result=>{ 
          // console.log(result)
          this.HisinitShow = true
          if(result.obj == undefined || result.obj.position.length == 0){
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].no_history)
            //開啟網頁操作
            Vue.prototype.$Global.Noneactive = ''
          }else{
            this.TimeZone = Vue.prototype.$Global.getTimeZone(this.FleetID)
            //開啟網頁操作
            Vue.prototype.$Global.Noneactive = ''
            //去除經緯度null的項目
            this.UnitDateTimeHistoryObj = this.UnitInfoFilterLatLngNull(result.obj.position).reverse()
            if(this.UnitDateTimeHistoryObj.length == 0){
              Vue.prototype.$Global.load = false
              alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].no_history)
              return
            }
            // console.log(this.UnitDateTimeHistoryObj)
            for(var i=0 ; i<this.UnitDateTimeHistoryObj.length;i++){
              Vue.prototype.$Global.EventDefChangeColor(this.UnitDateTimeHistoryObj[i].eventType,this.UnitDateTimeHistoryObj[i])
              Vue.prototype.$Global.SpeedChangeColor(this.UnitDateTimeHistoryObj[i].speed,this.UnitDateTimeHistoryObj[i])
              this.UnitDateTimeHistoryObj[i].no = i+1
            }
            //設定History表格Page
            this.HistoryNum = this.UnitDateTimeHistoryObj.length
            this.HistoryPageNum = Math.ceil(this.UnitDateTimeHistoryObj.length/jsonObject.OnePageHistoryNum)
            this.CurrentHistoryPage = 1
            // console.log(this.UnitDateTimeHistoryObj)
            if(this.HistoryCurrentNum == 1){
              //先打入第一個點
              var CurrentHistory = this.UnitDateTimeHistoryObj[this.HistoryCurrentNum-1]
              setTimeout(() => {//等軌跡畫完
                this.AddHistiryUnit(CurrentHistory)
              }, 500);
            }else{
              this.HistoryCurrentNum = 1
            }
            //是否加入 線
            if(this.TraceLineCheckboxValue){
              Vue.prototype.$Global.AddHistoryTraceline(this.UnitDateTimeHistoryObj)
            }
            //是否加入 箭頭
            if(this.TraceCheckboxValue){
              Vue.prototype.$LeafletMap.markers = []
              Vue.prototype.$Global.AddHistoryPathMark(this.UnitDateTimeHistoryObj)
              switch (Vue.prototype.$Global.MapType) {
                case 'Google':
                  break;
                case 'Leaflet':
                  if(Vue.prototype.$LeafletMap.markers.length > 0){
                    Vue.prototype.$LeafletMap.AddciLayer()
                  }
                  break;          
                default:
                  break;
              }
            }
            //處理事件列表 Filter History 中沒有的
            this.FixEventResourceFilterArr()
            //等待打點完畢
            setTimeout(() => {
              //Multifocus 所有的軌跡點
              Vue.prototype.$Global.Multifocus(this.UnitDateTimeHistoryObj)
            }, 500);
            //console.log(this.UnitDateTimeHistoryObj)
          }
          Vue.prototype.$Global.load = false
        })
      },
      //當地時機轉UTC時間
      LacalTimeToUTCTime(DateTime){//'07/29/2019 04:00:00'
        return new Date(DateTime).toISOString();
      },
      //停止播放歷史軌跡
      StopTrackHistory(){
        this.Nextmultiplication_num = 0
        this.Backmultiplication_num = 0
        clearInterval(this.PlayNextIntervalID)
        clearInterval(this.RewindIntervalID)
        this.PlayNextIntervalID = ''
        this.RewindIntervalID = ''
      },
      //播放
      PlayNextHistory(){
        if(this.Nextmultiplication_num >= 5) {
          this.Nextmultiplication_num = 1
        }else{
          this.Nextmultiplication_num++;
        }
        clearInterval(this.PlayNextIntervalID)
        var this_=this 
        this.PlayNextIntervalID = setInterval(function () {
          this_.NextHistory()
        }, jsonObject.HistorySpeed/this_.Nextmultiplication_num);
      },
      //倒播放
      RewindHistory(){
        if(this.Backmultiplication_num >= 5) {
          this.Backmultiplication_num = 1
        }else{
          this.Backmultiplication_num++;
        }
        clearInterval(this.RewindIntervalID)
        var this_=this 
        this.RewindIntervalID = setInterval(function () {
          this_.BackHistory()
        }, jsonObject.HistorySpeed/this_.Backmultiplication_num);
      },
      //播放到下一步
      NextHistory(){
        if(this.HistoryCurrentNum < this.HistoryNum){
          this.HistoryCurrentNum++
          //console.log(this.UnitDateTimeHistoryObj[this.HistoryCurrentNum-1])
        }else{
          this.PlayBoolean = false
        }
      },
      //播放到上一步
      BackHistory(){
        if(this.HistoryCurrentNum > 1){
          this.HistoryCurrentNum--
        }else{
          this.RewindBoolean = false
        }
      },
      //跳播到最後一步
      LastHistory(){
        this.HistoryCurrentNum = this.HistoryNum
      },
      //跳播到第一步
      FirstHistory(){
        this.HistoryCurrentNum = 1
      },
      //歷史軌跡打車輛點位
      AddHistiryUnit(Obj){
        var Bounds;
        switch (Vue.prototype.$Global.MapType) {
          case 'Google':
            if(Vue.prototype.$GoogleMap.HistoryUnitMarker != ''){
              Vue.prototype.$GoogleMap.RemoveOverlayMarkers(Vue.prototype.$GoogleMap.HistoryUnitMarker)
            }
            Bounds =  Vue.prototype.$GoogleMap.FMap.getBounds()
            var BoundObj = Bounds.toJSON()
            // console.log(BoundObj)
            // console.log(Obj.longitude)
            // console.log(Obj.latitude)
             //判斷有沒有超出可視範圍
            if(Obj.longitude < BoundObj.east && Obj.longitude > BoundObj.west && Obj.latitude < BoundObj.north && Obj.latitude > BoundObj.south){
              
            }else{
              Vue.prototype.$Global.SetCenterLatLngZ(Obj.latitude,Obj.longitude,Vue.prototype.$GoogleMap.FMap.getZoom())
            }
            Vue.prototype.$GoogleMap.AddOverlayMarker(Obj.latitude,Obj.longitude,'','HistoryUnitMark',Obj) 
            break;
          case 'Leaflet':
            if(Vue.prototype.$LeafletMap.HistoryUnitMarker != ''){
              Vue.prototype.$LeafletMap.RemoveHistoryUnitMarker(Vue.prototype.$LeafletMap.HistoryUnitMarker)
            }
            Bounds =  Vue.prototype.$LeafletMap.FMap.getBounds()
            //判斷有沒有超出可視範圍
            if(Obj.latitude < Bounds._northEast.lat && Obj.latitude > Bounds._southWest.lat && Obj.longitude < Bounds._northEast.lng && Obj.longitude > Bounds._southWest.lng){
              
            }else{
              Vue.prototype.$Global.SetCenterLatLngZ(Obj.latitude,Obj.longitude,Vue.prototype.$LeafletMap.FMap.getZoom())
            }
            Vue.prototype.$LeafletMap.AddMarker(Obj,'','HistoryUnitMark')
            break;       
          default:
            break;
        }
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/History.js